import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/ourmission/OurMission.css";
import libraryImg from "../../../assets/images/library.jpg"; // replace with your actual image path

const OurMission = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mission-section" ref={sectionRef}>
      {/* Subtle background orbs */}
      <div className="mission-orb mission-orb-1" />
      <div className="mission-orb mission-orb-2" />

      <Container className="mission-container">
        <Row className="align-items-center gy-4">
          {/* ---- Left: Text ---- */}
          <Col xs={12} lg={6}>
            <div className={`mission-text ${visible ? "text-animate" : ""}`}>
              <h2 className="mission-title">Our Mission</h2>

              <p className="mission-para">
                GGCW Library is a comprehensive Digital Library Management System
                designed to bridge the gap between traditional library systems
                and modern digital needs. Our platform enables students,
                faculty, and staff to seamlessly access, reserve, and manage
                library resources.
              </p>

              <p className="mission-para">
                We believe that knowledge should be accessible to everyone.
                Through our innovative platform, we provide digital PDFs,
                physical book reservations, note sharing capabilities, and
                AI-powered tools to enhance the learning experience.
              </p>
            </div>
          </Col>

          {/* ---- Right: Image ---- */}
          <Col xs={12} lg={6}>
            <div className={`mission-img-wrapper ${visible ? "img-animate" : ""}`}>
              <div className="mission-img-glow" />
              <img
                src={libraryImg}
                alt="Library shelves"
                className="mission-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OurMission;